import { axiosYtApiV2 } from "@/services/axios-yt-api-v2.js";

const axiosPlaces = {
  getPlaces(tourId) {
    return axiosYtApiV2.get(`tours/${tourId}/places`);
  },
};

export { axiosPlaces };
